import { useQuery } from 'react-query';
import { fetchUser } from 'v2/api';
import { infiniteStrapiUsersKeys } from './query-keys';

type UseStrapiUserProps = {
  id: number;
};

export function useStrapiUser({ id }: UseStrapiUserProps) {
  return useQuery({
    queryKey: infiniteStrapiUsersKeys.detail(id),
    queryFn: () => fetchUser(id),
  });
}
